module.exports = __webpack_public_path__ + "img/neutral--default.9c22cb70.svg";